import { STORE } from "@/store";
import { Router } from "@uuip/unified-ui-platform";
import { html, nothing } from "lit-html";
import style from "./QueueStatsDetailsBlock.scss";
const QueueStatsDetailsBlock = () => {
    return new Router.RouterView.Block({
        template: html `
      <div class="queue-detail">
        ${STORE.app.featureFlags.isQueueStatsDetailViewEnabled
            ? html `<div class="frame">
              <div class="queue-detail-box">
                <agentx-wc-queue-stats-detail
                  queueId=${STORE.agentContact.getSelectedQueueId}
                  orgId=${STORE.agent.orgId}
                  .isRTDIntialized=${STORE.app.isRTDIntialized}
                  @header-close-clicked=${() => {
                STORE.agentContact.selectedQueueStatsQueueChange("");
                STORE.layout.setRouterViewClasses({ expanded: false });
            }}
                >
                </agentx-wc-queue-stats-detail>
              </div>
            </div>`
            : nothing}
      </div>
    `,
        styles: style
    });
};
export default QueueStatsDetailsBlock;
